import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Inject,
  OnInit,
  Renderer2,
  ViewChild,
  PLATFORM_ID,
} from '@angular/core';
import {
  ChecklistDetailsResponse,
  Client,
  StyleSettingsDealerImage,
  ChecklistDetailsFileLinkWithThumbnail,
  ChecklistDetailsCheckPoints,
  ChecklistDetailsFinding,
  ChecklistDetailsCategories,
  DealerMediaResponse,
} from '../services/client.service';
import { AppService } from '../services/app.service';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { DownloadPdfService } from '../services/download-pdf.service';
import { CommonModule, DOCUMENT } from '@angular/common';
import { catchError, forkJoin, of } from 'rxjs';
import { VideoPlayerService } from '../services/video-player.service';
import { isPlatformBrowser } from '@angular/common';
import { MatAccordion, MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { VideoPlayerComponent } from '../video-player/video-player.component';
import { CarouselComponent } from '../carousel/carousel.component';
import { VehicleWalkthroughComponent } from '../vehicle-walkthrough/vehicle-walkthrough.component';
import { VvrVehicleWalkthroughComponent } from '../vvr-vehicle-walkthrough/vvr-vehicle-walkthrough.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatCardModule } from '@angular/material/card';
import {
  ButtonModule,
  IconModule,
  StructuredListModule,
  TilesModule,
} from 'carbon-components-angular';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatMenuModule } from '@angular/material/menu';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatButtonModule } from '@angular/material/button';
import { FeatureFlagService } from '../services/feature-flag.service';
import { MatSnackBarComponent } from '../mat-snack-bar/mat-snack-bar.component';

@Component({
  selector: 'app-visual-vehicle-reception-report',
  templateUrl: './visual-vehicle-reception-report.component.html',
  styleUrls: ['./visual-vehicle-reception-report.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatAccordion,
    MatIconModule,
    MatExpansionModule,
    VideoPlayerComponent,
    CarouselComponent,
    VvrVehicleWalkthroughComponent,
    VehicleWalkthroughComponent,
    MatDialogModule,
    MatCardModule,
    RouterModule,
    TilesModule,
    NgxExtendedPdfViewerModule,
    MatTabsModule,
    ButtonModule,
    StructuredListModule,
    IconModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    MatSnackBarModule,
    MatMenuModule,
    MatTooltipModule,
  ],
})
export class VisualVehicleReceptionReportComponent
  implements OnInit, AfterViewInit
{
  selectedCategory: any;
  reportResponse!: ChecklistDetailsResponse;
  @ViewChild('imageModal') imageModal: any;
  modalImageUrl: string | undefined;
  modalImageAlt: string | undefined;
  modelMedia!: ChecklistDetailsFileLinkWithThumbnail[];
  currentSelectedModel: number = 0;
  mediaElememt: string = '';
  formatedDateTime: string = '';
  @ViewChild('modelVideo') modelVideo!: ElementRef<HTMLVideoElement>;
  selectedCategoryIndex = 0;
  dealerImageDetails: StyleSettingsDealerImage | undefined;
  pdfBase64Data: string = '';
  token: string = '';
  pdfBase64String: string = '';
  isPDFDataAvailable: boolean = true;
  introOutroMediaData!: DealerMediaResponse;
  isWalkthroughEnabled: boolean | undefined = false;
  hasScrollbar: boolean = false;
  resizeObserver!: ResizeObserver;
  isScrollable: boolean = false;
  @ViewChild('bodyContainer') bodyContainerRef!: ElementRef;
  isAllowed = true;

  constructor(
    private elementRef: ElementRef,
    private client: Client,
    private route: ActivatedRoute,
    private appService: AppService,
    private pdfService: DownloadPdfService,
    private renderer: Renderer2,
    @Inject(DOCUMENT) private document: Document,
    private videoPlayerService: VideoPlayerService,
    private changeDetectorRef: ChangeDetectorRef,
    @Inject(PLATFORM_ID) private platformId: Object,
    private snackBar: MatSnackBar,
    private featureFlagService: FeatureFlagService
  ) {}

ngOnInit(): void {
  if (isPlatformBrowser(this.platformId)) {
    this.route.queryParams.subscribe((params) => {
      this.token = params['token'];

      this.featureFlagService.getFeatures(this.token, 'VVR-Report')
        .then(allowed => {
          if (!allowed) {
            this.isAllowed = false;
            this.snackBar.openFromComponent(MatSnackBarComponent, {
              data: `The feature "Visual Vehicle Reception  Report" is currently not enabled in MW Admin Portal - Feature Management. Please contact support for more information.`,
              duration: 10000,
              verticalPosition: 'bottom',
              horizontalPosition: 'center',
            });
            return;
          }

          
          forkJoin({
            data1: this.client.getChecklistDetails(this.token, true, 'EN'),
            data2: this.appService.getStyleSettings(this.token).pipe(
              catchError(() => {
                return of(null);
              })
            ),
            dealerMedia: this.appService.getDealerMediaResponse(this.token).pipe(
              catchError(() => {
                return of(null);
              })
            ),
          }).subscribe({
            next: (results: any) => {
              this.introOutroMediaData = results.dealerMedia;
              if (results.data1) {
                this.reportResponse = results.data1;
                this.modifyChecklistDetailsResponse(this.reportResponse);
                if (this.reportResponse.submittedDate) {
                  this.formatedDateTime = this.formatDate(this.reportResponse.submittedDate);
                }
              }
              this.dealerImageDetails = results.data2?.dealerImage;
            },
          });

          this.getChecklistReport(this.token);
        })
        .catch(() => {
          this.isAllowed = false;
        });
    });
  }
}


  ngAfterViewInit() {
    setTimeout(() => {
      this.changeDetectorRef.detectChanges();
      this.checkIfScrollable();
    }, 0);
  }

  modifyChecklistDetailsResponse(checklistDetails: ChecklistDetailsResponse) {
    if (!checklistDetails.categories) return;

    checklistDetails.categories.forEach(
      (category: ChecklistDetailsCategories) => {
        if (!category.checkpoints) return;

        category.checkpoints.forEach(
          (checkpoint: ChecklistDetailsCheckPoints) => {
            if (
              checkpoint.status === 'NotOK' &&
              checkpoint.findings &&
              checkpoint.findingTypeOptions
            ) {
              let hasRedFinding = checkpoint.findings.some(
                (finding: ChecklistDetailsFinding) =>
                  checkpoint?.findingTypeOptions?.some(
                    (option) =>
                      option.id === finding?.findingType?.id &&
                      option.color === 'Red'
                  )
              );

              if (hasRedFinding) {
                checkpoint.status = 'NotOKRed';
              }
            }
          }
        );
      }
    );
  }

  getChecklistReport(token: string) {
    this.client.getChecklistReport(token, 'EN').subscribe((data: string) => {
      this.pdfBase64Data = data;
      this.isPDFDataAvailable = true;
    });
  }

  downloadPDF() {
    if (this.pdfBase64Data) {
      this.pdfService.downloadPdf(
        this.pdfBase64Data,
        'Visual-Vehicle-Reception-Report.pdf',
        'application/pdf'
      );
    } else {
      this.isPDFDataAvailable = false;
    }
  }

  formatDate(dateString: string) {
    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear().toString().slice(-2);
    let hours = date.getHours();
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const ampm = hours >= 12 ? 'pm' : 'am';
    hours = hours % 12;
    hours = hours ? hours : 12;
    const formattedHours = hours.toString().padStart(2, '0');
    const formattedDate = `${day}.${month}.${year}, ${formattedHours}:${minutes}${ampm}`;

    return formattedDate;
  }

  imageUrl: any;
  closeMediaModal(
    media: ChecklistDetailsFileLinkWithThumbnail[] | any,
    position: number,
    isWalkthroughEnabled: boolean | undefined = this.isWalkthroughEnabled
  ) {
    this.isWalkthroughEnabled = isWalkthroughEnabled;
    this.modalImageUrl = '';
    if (this.modelVideo) {
      this.modelVideo.nativeElement.load();
    }
    this.modelMedia = media;
    if (position < 0) {
      position = 0;
    }
    if (position >= media.length) {
      position = media.length - 1;
    }
    if (media) {
      this.currentSelectedModel = position;
      this.modalImageUrl = media[position]?.url;
      this.imageModal.nativeElement.style.display = 'block';
      document
        .querySelector('.backdrop')
        ?.setAttribute('style', 'display:block');
    }
    this.mediaElememt = media[position].mimeType.includes('video')
      ? 'video'
      : 'image';
  }

  closeModal() {
    this.videoPlayerService.clearActivePlayer();
    if (this.modelVideo) {
      this.modelVideo.nativeElement.pause();
    }
    this.modalImageUrl = '';
    this.imageModal.nativeElement.style.display = 'none';
    document.querySelector('.backdrop')?.setAttribute('style', 'display:none');
  }

  scrollToElement(elementId: string) {
    const element = this.document.getElementById(elementId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    } else {
      console.error('Element not found:', elementId);
    }
  }

  checkIfScrollable() {
    const container = this.bodyContainerRef.nativeElement;
    this.isScrollable = container.scrollHeight > container.clientHeight;
  }

  isObjectEmpty(obj: any): boolean {
    return obj ? Object.keys(obj).length === 0 : true;
  }

  hasWalkthroughEnabledCheckpoints(
    category: ChecklistDetailsCategories
  ): boolean {
    return (
      category.checkpoints?.some(
        (checkpoint: ChecklistDetailsCheckPoints) =>
          checkpoint.isWalkthroughEnabled
      ) || false
    );
  }

  isCheckpointDisabled(category: ChecklistDetailsCategories): boolean {
    return (
      category.checkpoints?.some(
        (checkpoint: ChecklistDetailsCheckPoints) =>
          !checkpoint.isWalkthroughEnabled
      ) ?? false
    );
  }
}
